// I SIMBOLI DEI TASTI SONO SCRITTI ALLA MANIERA DEL MAC, e chi non sta su un Mac legge un'altra
// cosa. «⇧click for a range · ⌘click one by one» su Windows deve dire «Shift+click… Ctrl+click…»,
// e la traduzione si fa QUI e non nelle stringhe: le stringhe sono una sola per tutti i sistemi,
// e riscriverle con dentro tutti e due i simboli farebbe leggere a ciascuno anche la barra
// dell'altro.
//
// LA TAVOLA È ORDINATA, e l'ordine è la correzione: «⇧⌘» va cercato PRIMA di «⌘», o «⇧⌘Z»
// diventerebbe «⇧Ctrl+Z» — il pezzo lungo non si ricompone più una volta che gli hai mangiato il
// pezzo corto.
const KEYS: [string, string][] = [
    ['⇧⌘', 'Ctrl+Shift+'],
    ['⌘', 'Ctrl+'],
    ['⇧', 'Shift+'],
    ['⌥', 'Alt+'],
    ['⌫', 'Del']
];

// `navigator.platform` È DEPRECATO, e resta comunque il ripiego: è la sola via su Safari e
// Firefox, dove `userAgentData` non esiste. Su Chrome si chiede prima quello nuovo, che risponde
// "macOS". Il terzo termine è la rete: se sparissero tutti e due, non-Mac è la scelta che sbaglia
// meno — Ctrl si legge ovunque, ⌘ solo su un sistema.
const uaData = (navigator as Navigator & { userAgentData?: { platform?: string } }).userAgentData;

const IS_MAC = uaData && uaData.platform ? uaData.platform === 'macOS' : /Mac|iPhone|iPad|iPod/.test(navigator.platform || navigator.userAgent || '');

/**
 * Scrive i modificatori nella lingua del sistema di chi guarda. Su Mac non fa niente: i simboli
 * sono già i suoi.
 */
export const keyText = (text: string): string => {
    if (IS_MAC) return text;
    return KEYS.reduce((acc, [mac, other]) => acc.split(mac).join(other), text);
};
